module.exports = __webpack_public_path__ + "img/pIndex-t-slide3.fd610417.jpg";